import { render } from "./OtiClockOp.vue?vue&type=template&id=f847c97c&scoped=true"
import script from "./OtiClockOp.vue?vue&type=script&lang=js"
export * from "./OtiClockOp.vue?vue&type=script&lang=js"

import "./OtiClockOp.vue?vue&type=style&index=0&id=f847c97c&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f847c97c"]])

export default __exports__